var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageManager',{attrs:{"iframe-target":`${_vm.link}/shops`,"page":"physical-shops"}})
}
var staticRenderFns = []

export { render, staticRenderFns }